<template>
  <div class="push__bottom">
			<details class="details">
				<summary @click='toggle()' class="details__btn js-details__btn" :class="activeClass" role="button" type="button" tabindex="0" :aria-expanded="isOpen">
					<span class="details__summary-text">
						{{title}} 
					</span>
				</summary>
				<div class="details__bd inset-text wysiwyg" :class="activeClass" tabindex="0" :aria-hidden="!isOpen" v-html="message">
				</div>				
			</details>
	</div>
</template>

<script>
export default {
	name: 'Details',
	props: {
		id: String,
		title: String,
		message: String,
	},
	data() {
		return {
			isOpen: false,
			activeClass: "",
		};
	},
	methods: {
		toggle: function () {
			this.isOpen = !this.isOpen;
			this.activeClass = this.isOpen ? "is--active" : ""
		}
	}
}
</script>